<template>
  <div class="w-100 bg-light-page">
    <div id="hotel-room-booking"></div>
    <div id="hotel-room-payment"></div>
    <!-- <topNavbar page="cart"></topNavbar> -->
    <!-- <GeneralTopNavbar :steps="steps" :current-step="currentStep" /> -->
    <HotelTopNavbar page="cart" />
    <block :height="$is_mobile_view ? 135 : 83" />

    <div class="ga-container fluid d-block pb-5">
      <div class="row">
        <!-- <div class="col-12 mb-4 pb-2">
          <div class="box-shadow-main rounded-6 w-100 p-3 bg-white">
            <headerStepOrder :step="order_step" :need_payment="is_order_need_payment"></headerStepOrder>
          </div>
        </div> -->
        <div class="col-7 col-lg-8" id="contact-form">
          <template v-if="!show_xendit_cc_form">
            <!-- INQUIRY -->
            <template v-if="cart_step == 1">
              <!-- Login -->
              <!-- <div class="mb-4 pb-2" v-if="isNotLogin">
                <div class="box-shadow-main rounded-6">
                  <div class="px-4 pt-4 pb-2 rounded-6 bg-white">
                    <img
                      src="../../../assets/img/icon/user.png"
                      class="position-relative rounded-100 p-1 object-fit mr-3 d-inline-block"
                      height="50"
                      width="50"
                      style="top: -13px; background-color: #cfcfcf" />
                    <div class="d-inline-block">
                      <p class="mb-0 body-2-2 font-semibold text-16">
                        {{ $t('hotel.user.youre-not') }}
                        <router-link :to="'/' + getMerchant.code + '/login'"
                          ><span
                            @click="setActiveRoute('cart')"
                            class="underline text-green cursor-pointer body-2-2 font-bold"
                            >{{ $t('hotel.user.login') }}</span
                          ></router-link
                        >
                        {{ $t('hotel.user.or') }}
                        <router-link :to="'/' + getMerchant.code + '/register'"
                          ><span
                            @click="setActiveRoute('cart')"
                            class="underline text-green cursor-pointer body-2-2 font-bold"
                            >{{ $t('hotel.user.register') }}</span
                          ></router-link
                        >
                      </p>
                      <p class="mb-0 body-2 font-regular">
                        {{ $t('hotel.user.login-now') }}
                      </p>
                    </div>
                  </div>
                </div>
              </div> -->
              <!-- Contact Form -->
              <div class="my-4">
                <HotelCheckoutStepper
                  :steps="steps"
                  :current-step="currentStep" />
              </div>
              <div v-if="show_contact_form" class="mb-4 pb-2">
                <div class="box-shadow-main rounded-6 border">
                  <div class="px-4 py-4 rounded-6 bg-white">
                    <p class="mb-4 body-2-2 text-20 font-bold">
                      {{ $t('hotel.contact-detail.title') }}
                    </p>
                    <div class="mb-3">
                      <!-- <ContactForm 
                      :error_check="error_check"
                      ></ContactForm> -->
                      <FormGuestDetail ref="contact_form"></FormGuestDetail>
                    </div>
                    <template>
                      <div class="row slim-grid-row mt-4" id="visitor-form">
                        <div class="col-12 mb-2">
                          <div
                            class="w-16px rounded-100 border-2-green mt-2px d-inline-block mr-2 cursor-pointer"
                            @click="setBeTicketOwner('me')">
                            <div
                              class="w-8px rounded-100 position-relative mx-auto mt-2px"
                              :class="{
                                'bg-green': ticket_owner == 'me',
                              }"></div>
                          </div>
                          <p
                            class="mb-0 body-2 font-regular d-inline-block text-16 position-relative cursor-pointer"
                            @click="setBeTicketOwner('me')"
                            style="top: -3px">
                            {{ $t('hotel.contact-detail.iam-guest') }}
                          </p>
                        </div>
                        <div class="col-12">
                          <div
                            class="w-16px rounded-100 border-2-green mt-2px d-inline-block mr-2 cursor-pointer"
                            @click="
                              setBeTicketOwner('other');
                              toggleVisitorForm();
                            ">
                            <div
                              class="w-8px rounded-100 position-relative mx-auto mt-2px"
                              :class="{
                                'bg-green': ticket_owner == 'other',
                              }"></div>
                          </div>
                          <p
                            class="mb-0 body-2 font-regular d-inline-block text-16 position-relative cursor-pointer"
                            style="top: -3px"
                            @click="
                              setBeTicketOwner('other');
                              toggleVisitorForm();
                            ">
                            {{ $t('hotel.contact-detail.iam-not-guest') }}
                          </p>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <!-- Visitor Information -->
              <template v-if="ticket_owner != 'me'">
                <div class="mb-4 pb-2">
                  <div class="box-shadow-main rounded-6 border">
                    <div class="px-4 py-4 rounded-6 bg-white position-relative">
                      <div class="row">
                        <div class="col-11">
                          <p class="mb-0 body-2-2 text-20 font-bold">
                            {{ $t('hotel.visitor-detail.visitor-detail') }}
                          </p>
                          <p
                            class="mb-3 body-2 font-regular text-14 cursor-pointer"
                            @click="toggleVisitorForm()">
                            {{ $t('hotel.visitor-detail.tap-detail') }}
                          </p>
                        </div>
                        <div
                          class="col-1 text-right"
                          @click="toggleVisitorForm()">
                          <svg
                            class="cursor-pointer"
                            width="24"
                            height="20"
                            viewBox="0 0 20 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M16.3687 0.290009L18.7087 2.63C19.0988 3.01999 19.0988 3.64999 18.7087 4.04001L16.8788 5.87L13.1288 2.12L14.9587 0.290009C15.1487 0.100006 15.3987 0 15.6588 0C15.9188 0 16.1688 0.0899963 16.3687 0.290009ZM0.998749 14.25V18H4.74875L15.8087 6.94L12.0587 3.19L0.998749 14.25ZM3.91876 16H2.99875V15.08L12.0587 6.01999L12.9788 6.94L3.91876 16Z"
                              class="fill-primary" />
                          </svg>
                        </div>
                      </div>
                      <div class="mb-3 position-relative">
                        <div
                          class="cursor-pointer py-3 px-4 rounded-6 border-form"
                          @click="toggleVisitorForm()">
                          <div class="row">
                            <div class="col-6 mb-3">
                              <p class="mb-0 body-3">
                                {{ $t('hotel.visitor-detail.full-name') }}
                              </p>
                              <p class="mb-0 body-2-4">
                                {{
                                  visitor_data.name == ''
                                    ? '-'
                                    : visitor_data.name
                                }}
                              </p>
                            </div>
                            <div
                              class="col-6 mb-3"
                              v-if="visitor_data.date_of_birth != 'HIDE'">
                              <p class="mb-0 body-3">
                                {{ $t('hotel.visitor-detail.date-of-birth') }}
                              </p>
                              <p class="mb-1 body-2-4">
                                {{
                                  visitor_data.date_of_birth == ''
                                    ? '-'
                                    : visitor_data.date_of_birth ==
                                      'Invalid date'
                                    ? visitor_data.date_of_birth
                                    : $formatDate(visitor_data.date_of_birth)
                                }}
                              </p>
                            </div>
                            <div
                              class="col-6 mb-3"
                              v-if="visitor_data.country != 'HIDE'">
                              <p class="mb-0 body-3">
                                {{ $t('hotel.visitor-detail.country') }}
                              </p>
                              <p class="mb-1 body-2-4">
                                {{
                                  visitor_data.country == ''
                                    ? '-'
                                    : visitor_data.country
                                }}
                              </p>
                            </div>
                            <div
                              class="col-6 mb-3"
                              v-if="visitor_data.nationality != 'HIDE'">
                              <p class="mb-0 body-3">
                                {{ $t('hotel.visitor-detail.nationality') }}
                              </p>
                              <p class="mb-1 body-2-4">
                                {{
                                  visitor_data.nationality == ''
                                    ? '-'
                                    : visitor_data.nationality
                                }}
                              </p>
                            </div>
                            <div class="col-6">
                              <p class="mb-0 body-3">
                                {{ $t('hotel.visitor-detail.phone-number') }}
                              </p>
                              <p class="mb-1 body-2-4">
                                {{
                                  visitor_data.phone_number == ''
                                    ? '-'
                                    : visitor_data.phone_number
                                }}
                              </p>
                            </div>
                            <div class="col-6">
                              <p class="mb-0 body-3">
                                {{ $t('hotel.visitor-detail.email') }}
                              </p>
                              <p class="mb-1 body-2-4">
                                {{
                                  visitor_data.email == ''
                                    ? '-'
                                    : visitor_data.email
                                }}
                              </p>
                            </div>
                          </div>
                        </div>
                        <p
                          class="mb-0 mt-2 text-danger body-2 text-12 font-regular delay"
                          v-if="!visitor_form_valid">
                          {{ $t('hotel.visitor-detail.visitor-information') }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <TransportServices />
              <!-- Additional Service -->
              <AdditionalService
                v-if="
                  getMerchant.additional_appearance === 'CART'
                "></AdditionalService>
              <!-- Special Request -->
              <SpecialRequest></SpecialRequest>
              <!-- Promo Code -->
              <PromoCode @applyPromoCode="applyPromoCode"></PromoCode>
              <!-- PAYMENT OPTION -->
              <div
                class="box-shadow-main rounded-6 w-100 bg-white mb-4"
                :class="payment_option_error ? 'border-danger' : 'border'"
                v-if="show_guarantee_deposit">
                <!-- <span class="text-danger body-3-3 p-3">Don't touch it. Still under development</span> -->
                <PaymentOption
                  ref="payment_option"
                  @submitPaymentOption="submitPaymentOption"
                  @changeStatusCC="changeStatusCC"
                  @getCreditCardId="getCreditCardId"></PaymentOption>
              </div>
            </template>

            <!-- PAYMENT -->
            <template v-if="cart_step == 2">
              <div v-if="pm_loader" class="w-100 my-5 text-center">
                <loader />
              </div>
              <template v-else>
                <div class="my-4">
                  <HotelCheckoutStepper
                    :steps="steps"
                    :current-step="currentStep" />
                </div>
                <div class="p-3 d-block" v-if="error.payment_list != ''">
                  <div
                    class="p-3 border radius-0"
                    style="
                      background-color: rgb(255, 243, 243);
                      border-color: #feb8b8 !important;
                    ">
                    <div class="row grid-slim-row">
                      <div class="col-12 text-center">
                        <p class="mb-0 body-3-1">{{ error.payment_list }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-4 pb-2" v-else>
                  <div class="box-shadow-main rounded-6">
                    <div class="px-4 py-4 rounded-6 bg-white">
                      <p class="mb-2 body-2-2 text-20 font-bold">
                        {{ $t('hotel.payment-method.choose-payment-method') }}
                      </p>
                      <p
                        class="mb-4 body-2-2 text-14 font-regular html-desc"
                        v-html="getMerchant.payment_description"></p>
                      <!-- <p class="mb-1 body-2-2 font-regular">Deposit required of <span class="font-bold">{{formatCurrency(total_deposit)}}</span></p> -->
                      <!-- Payment Methods -->
                      <div class="row slim-grid-row">
                        <div
                          class="col-12 col-lg-12"
                          v-for="(pm, index) in payment_methods"
                          @click="togglePayment(index)">
                          <div
                            class="mb-3 px-3 py-2 rounded-6 delay cursor-pointer box-shadow-main overflow-hidden"
                            :class="{
                              'border-green bg-light-page h-auto':
                                pm.is_selected,
                            }"
                            style="
                              background-color: #fff;
                              border: 1px solid #dee2e6;
                              height: 86px;
                            ">
                            <div class="row no-gutters py-1">
                              <div class="col-9 col-lg-10">
                                <div class="row no-gutters">
                                  <div class="col-1 align-self-start">
                                    <div
                                      class="w-16px rounded-100 border-2-green"
                                      style="margin-top: 12px">
                                      <div
                                        class="w-8px rounded-100 position-relative mx-auto mt-2px"
                                        :class="{
                                          'bg-green': pm.is_selected,
                                        }"></div>
                                    </div>
                                  </div>
                                  <div class="col-11 align-self-start">
                                    <p
                                      class="mb-0 body-2-2 font-bold text-18 mt-1"
                                      style="line-height: 1 !important">
                                      {{ pm.data.name }}
                                    </p>
                                    <span
                                      v-if="
                                        pm.data.bank_name == 'DIRECT_PAYMENT' ||
                                        (pm.data.bank_name == 'WISE' &&
                                          pm.data.payment_method ==
                                            'BANK_TRANSFER')
                                      "
                                      class="body-3-3-2 mb-0 text-orange d-block"
                                      >{{
                                        $t('general.manually-checked')
                                      }}</span
                                    >
                                    <span
                                      v-else
                                      class="body-3-3-2 mb-0 text-green d-block"
                                      >{{
                                        $t('general.checked-automatically')
                                      }}</span
                                    >
                                    <p
                                      class="mb-0 body-2-2 text-14 html-desc text-truncate-inside"
                                      v-if="!pm.is_selected"
                                      style="height: 21px; overflow: hidden"
                                      v-html="pm.data.description"></p>
                                    <p
                                      class="mb-0 body-2-2 text-14"
                                      v-else
                                      v-html="pm.data.description"></p>
                                  </div>
                                  <!-- <div class="col-12 mt-2" v-if="pm.is_selected">
                                    <p class="mb-1 d-block body-2-2 text-14">{{$t("general.description")}}</p>
                                  </div> -->
                                </div>
                              </div>
                              <div class="col-3 col-lg-2 text-right">
                                <img
                                  :src="pm.data.image_url"
                                  style="
                                    max-width: 100%;
                                    height: 52px;
                                    object-fit: contain;
                                  " />
                              </div>
                              <!-- <div class="col-12" v-if="pm.is_selected">
                                <p class="mb-0 mt-1 body-2-2 text-14 html-desc" v-html="pm.data.description"></p>
                              </div> -->
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- ERROR MESSAGE -->
                      <div class="p-3 d-block" v-if="error.payment != ''">
                        <div
                          class="p-3 border radius-0"
                          style="
                            background-color: rgb(255, 243, 243);
                            border-color: #feb8b8 !important;
                          ">
                          <div class="row grid-slim-row">
                            <div class="col-12 text-center">
                              <p class="mb-0 body-3-1">{{ error.payment }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </template>

            <!-- Button & Term Conditions -->
            <div class="mb-3 px-4">
              <!-- TERMS & CONDITIONS -->
              <div class="mt-2" v-if="cart_step == 1">
                <div
                  class="w-16px rounded border-2-orange text-center delay mt-2px mr-2 d-inline-block cursor-pointer position-relative"
                  :class="{ 'bg-orange': term_conditions_check }"
                  @click="termConditionCheck()">
                  <img
                    src="../../../assets/img/icon/correct-white.png"
                    class="position-relative"
                    width="10"
                    style="top: -8px" />
                </div>
                <p
                  class="mb-0 body-2-2 font-regular position-absolute d-inline-block cursor-pointer"
                  :class="{ 'text-orange': term_conditions_error }"
                  @click="termConditionCheck()">
                  {{ $t('hotel.accepted-term-condition') }}
                  {{ $t('merchant.term-condition') }}.
                </p>
              </div>

              <!-- BUTTON SUBMIT -->
              <div class="mt-3">
                <state-button
                  ref="submitBtnCart"
                  :disabled="button_submit_not_valid"
                  :click="submitAction"
                  size="lg"
                  variant="secondary">
                  {{ button_submit_text }}
                </state-button>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="my-4">
              <HotelCheckoutStepper
                :steps="steps"
                :current-step="currentStep" />
            </div>
            <XenditInputCC
              :tx_payment="tx_payment"
              @done="clearCart"
              @done-destroyed="toggleClearCartDestroyed"
              @expired="closeXenditCC">
            </XenditInputCC>
          </template>
        </div>
        <!-- Cart -->
        <div class="col-5 col-lg-4 mb-4 pb-2">
          <div class="sticky" style="top: 95px">
            <Cart
              ref="desktopCart"
              :cart_step="cart_step"
              :show_room="show_room_cart"
              @detailRoom="detailRoom"
              @adjustPax="toggleAdjustPax"
              @register-ref="handlePrimaryRef"
              @register-tr-ref="handleTransportRouteRef" 
              :payment_surcharge="payment_surcharge"
              :payment_method="pm_selected"
              :total_deposit_merchant="total_deposit_merchant"></Cart>
            <div
              v-if="promo_code_applied_failed.show"
              class="w-100 p-2 border-semi-grey radius-8 bg-white">
              <div class="pb-2 border-b-semi-grey text-center">
                <p class="body-2-1 mb-0">
                  {{ promo_code_applied_failed.promo.name }}
                </p>
                <p class="body-3-3-1 mb-0">
                  CODE :
                  <span class="font-bold text-green">{{
                    promo_code_applied_failed.promo.promo_code
                  }}</span>
                </p>
              </div>
              <div
                class="mt-2 p-2 text-center"
                style="
                  background-color: rgb(255, 210, 195);
                  border-color: rgb(247, 111, 111) !important;
                ">
                <p class="mb-0 body-2-1">
                  Sorry, this promo has no effect on the room you have selected
                </p>
              </div>
            </div>
            <ClaimingReward wrapper_class="mt-5"></ClaimingReward>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="w-100 px-5">
      <div class="px-3 py-4">
        
      </div>
    </div> -->
    <!-- POPUP DEPOSIT 0 -->
    <transition name="fade">
      <template v-if="popup_deposit == 'show' && error_check == ''">
        <div class="w-100">
          <div class="position-relative z-index-1045">
            <div class="row no-gutters justify-content-center">
              <div class="fixed-bottom d-block nav-bottom" style="top: 23%">
                <div class="custom-container-fluid px-0">
                  <div class="row justify-content-center no-gutters">
                    <div
                      class="col-xl-4 col-lg-5 col-md-5 col-sm-8 col-12 position-relative">
                      <div class="bg-white mx-5 rounded-6">
                        <div class="w-100 py-4 px-2">
                          <div
                            class="container px-4 text-center position-relative">
                            <p class="mb-0 body-2-2 text-20 font-extrabold">
                              {{
                                $t(
                                  'hotel.Are you sure to create this reservation?'
                                )
                              }}
                            </p>
                            <p class="mb-3 body-2-2 font-regular text-14">
                              {{
                                $t('hotel.Make sure you choose the best offer')
                              }}
                            </p>
                            <div class="row">
                              <div class="col-4">
                                <button
                                  class="g-btn g-btn-light g-btn-lg mb-3 w-100"
                                  @click="
                                    deposit_warning = false;
                                    popup_deposit = false;
                                  ">
                                  {{ $t('general.back') }}
                                </button>
                              </div>
                              <div class="col-8">
                                <state-button
                                  :disabled="!term_conditions_check"
                                  :click="errorCheck"
                                  size="lg"
                                  block
                                  variant="secondary">
                                  {{ $t('ticket-cart.continue') }}
                                </state-button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </transition>
    <!-- Footer -->
    <Footer></Footer>
    <template v-if="terms_conditions">
      <transition name="fade">
        <TermsConditions @togglePopUp="togglePopUp"></TermsConditions>
      </transition>
    </template>

    <!-- INVALID PAX -->
    <popup-detail
      id_ref="invalid_pax"
      direction="bottom"
      :show="invalid_pax.show"
      use_max_size
      wrapper_size="mobile"
      use_footer
      no_close_backdrop
      @close="toggleInvalidPax">
      <template v-slot:body>
        <div class="py-5 px-4 text-center" v-if="invalid_pax.show">
          <div class="rounded-100 my-2 w-20 mx-auto">
            <div class="bg-warning rounded-100 mx-auto size-icon-in">
              <div class="pt-3">
                <svg
                  width="38"
                  height="32"
                  viewBox="0 0 38 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0.666672 31.8333L19 0.166656L37.3333 31.8333H0.666672ZM31.55 28.5L19 6.81666L6.45001 28.5H31.55ZM17.3333 23.5V26.8333H20.6667V23.5H17.3333ZM17.3333 13.5H20.6667V20.1667H17.3333V13.5Z"
                    fill="white" />
                </svg>
              </div>
            </div>
          </div>
          <p class="mb-0 body-2-2 text-18 text-green font-extrabold">
            Incomplete data
          </p>
          <p class="mb-2 body-2-2">
            In the <b>{{ invalid_pax.data }}</b> the total number of guests
            staying is still 0, please complete the total number of guests in
            that room
          </p>
        </div>
      </template>
      <template v-slot:footer>
        <div class="px-3 pt-3">
          <button @click="openAdjustPaxFromWarning" class="ga-btn-primary-lg">
            Check Room Pax
          </button>
        </div>
      </template>
    </popup-detail>

    <!-- Warning -->
    <template
      v-if="getBeCart.room_rate_details.length == 0 || error.inquiry != ''">
      <PopUpWarning
        :data="error.inquiry"
        @close="clearInquiryError()"></PopUpWarning>
    </template>
    <template v-if="cart_step == 1 && error.payment != ''">
      <WarningBox
        title="Transaction Failed"
        :body="error.payment"
        btn_primary="Close"
        @yes="clearPaymentError">
      </WarningBox>
    </template>

    <!-- Room Type Detail-->
    <template v-if="detail_room">
      <transition name="fade">
        <RoomRatesDetail
          @detailRoom="detailRoom"
          :data="detail_room"></RoomRatesDetail>
      </transition>
    </template>

    <!-- Popup Background -->
    <template
      v-if="
        detail_room ||
        terms_conditions ||
        getBeCart.room_rate_details.length == 0 ||
        error.inquiry != '' ||
        (popup_deposit == 'show' && error_check == '')
      ">
      <transition name="fade">
        <PopUpBackground :data="detail_room"></PopUpBackground>
      </transition>
    </template>

    <form
      :action="dkpayload.URL"
      method="post"
      id="dkpayform2018"
      name="dkpayform2018"
      ref="FormDKload">
      <input name="MALLID" type="hidden" v-model="dkpayload.MALLID" />
      <input name="BASKET" type="hidden" v-model="dkpayload.BASKET" />
      <input
        name="CHAINMERCHANT"
        type="hidden"
        v-model="dkpayload.CHAINMERCHANT" />
      <input name="AMOUNT" type="hidden" v-model="dkpayload.AMOUNT" />
      <input
        name="PURCHASEAMOUNT"
        type="hidden"
        v-model="dkpayload.PURCHASEAMOUNT" />
      <input
        name="TRANSIDMERCHANT"
        type="hidden"
        v-model="dkpayload.TRANSIDMERCHANT" />
      <input name="WORDS" type="hidden" v-model="dkpayload.WORDS" />
      <input name="CURRENCY" type="hidden" v-model="dkpayload.CURRENCY" />
      <input
        name="PURCHASECURRENCY"
        type="hidden"
        v-model="dkpayload.PURCHASECURRENCY" />
      <input name="COUNTRY" type="hidden" v-model="dkpayload.COUNTRY" />
      <input name="SESSIONID" type="hidden" v-model="dkpayload.SESSIONID" />
      <input
        name="PAYMENTCHANNEL"
        type="hidden"
        v-model="dkpayload.PAYMENTCHANNEL" />
      <input
        name="REQUESTDATETIME"
        type="hidden"
        v-model="dkpayload.REQUESTDATETIME" />
      <input name="NAME" type="hidden" v-model="dkpayload.NAME" />
      <input name="EMAIL" type="hidden" v-model="dkpayload.EMAIL" />
      <input name="ADDRESS" type="hidden" v-model="dkpayload.ADDRESS" />
      <input name="MOBILEPHONE" type="hidden" v-model="dkpayload.MOBILEPHONE" />
    </form>

    <popup-detail
      id_ref="adjust_pax"
      direction="bottom"
      :show="adjust_pax.show"
      use_max_size
      wrapper_size="mobile"
      @close="toggleAdjustPax"
      no_close_backdrop>
      <template v-slot:header>
        <div class="d-flex align-items-center justify-content-between p-4 border-b-form">
          <div class="pr-3">
            <p class="mb-0 body-1-4">Guest Details</p>
            <p class="mb-0 body-2">Adjust room guests and details if required.</p>
          </div>
          <div @click="toggleAdjustPax()" class="p-2-5 rounded border-form cursor-pointer lh-0 bg-light">
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.8 2.21L13.39 0.800003L7.8 6.39L2.21 0.800003L0.800003 2.21L6.39 7.8L0.800003 13.39L2.21 14.8L7.8 9.21L13.39 14.8L14.8 13.39L9.21 7.8L14.8 2.21Z" fill="#222222"/>
            </svg>
          </div>
        </div>
      </template>
      <template v-slot:body>
        <AdjustPax
          v-if="adjust_pax.data.guest"
          :data="adjust_pax.data"
          :validate-child-age="adjust_pax.valdiateAgeChild"
          @close="toggleAdjustPax"
          @openDetail="detailRoom"></AdjustPax>
      </template>
    </popup-detail>

    <!-- VISITOR FORM -->
    <popup-detail
      id_ref="visitor-form"
      direction="bottom"
      :show="visitor_form"
      use_max_size
      wrapper_size="mobile"
      title="Visitor contact detail"
      @close="toggleVisitorForm"
      use_footer
      no_close_backdrop>
      <template v-slot:body>
        <div class="px-4" :key="visitor_form_key">
          <FormGuestDetail
            ref="contact_visitor_form"
            guest_type="someone"
            viewtype="mobile"></FormGuestDetail>
        </div>
      </template>
      <template v-slot:footer>
        <div class="p-4">
          <state-button
            variant="primary"
            size="lg"
            block
            :click="saveVisitorForm">
            Save
          </state-button>
        </div>
      </template>
    </popup-detail>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import { post, get } from '@/services/index.js';
import config from '@/config/index.js';
import moment from 'moment';
import { formatCurrency, paymentMethodConverter } from '@/utils/index.js';
import Form from '../../../base';
import Footer from '@/components/hotel/Footer.vue';
import RoomRatesDetail from '@/components/hotel/be/desktop/roomRatesDetail.vue';
import PopUpBackground from '@/components/hotel/be/PopUpBackgroundDesktop.vue';
import ContactForm from '@/components/hotel/be/desktop/contactForm.vue';
import AdditionalService from '@/components/hotel/be/additionalService';
import PromoCode from '@/components/hotel/be/desktop/promoCode.vue';
import SpecialRequest from '@/components/hotel/be/desktop/specialRequest.vue';
import topNavbar from '@/components/hotel/be/desktop/navbar.vue';
import headerStepOrder from '@/components/hotel/be/desktop/headerStepOrder.vue';
import Cart from '@/components/hotel/be/desktop/cart.vue';
import TermsConditions from '@/components/hotel/be/desktop/termsConditions.vue';
import PopUpWarning from '@/components/hotel/be/PopUpWarning';
import XenditInputCC from '@/components/hotel/be/XenditInputCC';
import PaymentOption from '@/components/hotel/be/PaymentOption';
import WarningBox from '@/components/general/WarningBox';
import AdjustPax from '../../../components/hotel/be/AdjustPax.vue';
import ClaimingReward from '@/components/hotel/general/ClaimingReward.vue';
import FormGuestDetail from '../../../components/hotel/be/FormGuestDetail.vue';
import GeneralTopNavbar from '../../../components/general/GeneralTopNavbar.vue';
import HotelTopNavbar from '../../../components/hotel/HotelTopNavbar.vue';
import HotelCheckoutStepper from '../../../components/hotel/be/HotelCheckoutStepper.vue';
import TransportServices from '../../../components/hotel/be/TransportServices.vue';
import { trackEvent } from '../../../utils/analytics';

export default {
  components: {
    Footer,
    RoomRatesDetail,
    PopUpBackground,
    ContactForm,
    AdditionalService,
    SpecialRequest,
    topNavbar,
    Cart,
    TermsConditions,
    PopUpWarning,
    PromoCode,
    XenditInputCC,
    WarningBox,
    headerStepOrder,
    PaymentOption,
    AdjustPax,
    ClaimingReward,
    FormGuestDetail,
    GeneralTopNavbar,
    HotelTopNavbar,
    HotelCheckoutStepper,
    TransportServices
  },
  data() {
    return {
      steps: [
        { order: 1, title: 'Your Selection' },
        { order: 2, title: 'Your Details' },
        { order: 3, title: 'Final Step' },
      ],
      currentStep: 2,
      order_step: 2,
      is_order_need_payment: false,
      popup_deposit: false,
      deposit_warning: false,
      detail_room: false,
      term_conditions_check: false,
      scrollPosition: null,
      is_step: '1',
      terms_conditions: false,
      contact_form: 'customer',
      form_size: false,
      error_check: false,
      term_conditions_error: false,
      push_loading: {
        inquiry: false,
        payment: false,
      },
      error: {
        inquiry: '',
        payment: '',
        payment_list: '',
      },
      cart_step: 1,
      tx_inquiry: {},
      payment_surcharge: 0,
      pm_selected: {},
      total_payment: 0,
      payment_methods: [],
      pm_loader: false,
      dkpayload: new Form({
        MALLID: '',
        BASKET: '',
        CHAINMERCHANT: '',
        AMOUNT: '',
        PURCHASEAMOUNT: '',
        TRANSIDMERCHANT: '',
        WORDS: '',
        REQUESTDATETIME: '',
        CURRENCY: '',
        PURCHASECURRENCY: '',
        SESSIONID: '',
        PAYMENTCHANNEL: '',
        NAME: '',
        EMAIL: '',
        ADDRESS: '',
        COUNTRY: '',
        URL: '',
      }),
      show_contact_form: false,
      radio_button: '',
      show_xendit_cc_form: false,
      tx_payment: {},
      promo_code_applied_failed: {
        show: false,
        promo: {},
      },
      payment_option: {},
      payment_option_error: false,
      payment_option_valid: false,
      credit_card_guarantee_id: '',
      adjust_pax: {
        show: false,
        data: {},
        valdiateAgeChild: false
      },
      invalid_pax: {
        show: false,
        data: '',
      },
      visitor_form: false,
      visitor_form_valid: true,
      visitor_form_key: 0,
      clear_cart_when_destroyed: false,
      clear_cart_when_change_page: false,
      productPrimaryRef: null,
      transportRouteRef: []
    };
  },
  computed: {
    ...mapGetters([
      'getMerchant',
      'isNotLogin',
      'getBeCart',
      'getBeFilter',
      'getBeRoomDeposit',
      'getBeAddtServiceDeposit',
      'getIsCartVisitorEmail',
      'getBeTicketOwner',
      'getBeAddtServiceSubTotal',
      'getAgentId',
      'getBeTxPayment',
      'getSessionLog',
      'getBeRoomTotal',
      'getBeBypassCcGuarantee',
      'getBeIsInvalIdPax',
      'getMembershipRewardApplied',
      'getActivityTrxProducts',
      'getOutletTrxProducts',
      'getVoucherOrder',
      'getMembershipReferral',
    ]),
    visitor_data() {
      let vuex_data = this.getBeCart.visitor_details;
      let return_data = {
        name: '',
        email: vuex_data.email,
        phone_number: vuex_data.phone_number,
        country:
          this.getMerchant.booking_engine_country != 'HIDE'
            ? vuex_data.country
            : 'HIDE',
        nationality:
          this.getMerchant.booking_engine_nationality != 'HIDE'
            ? vuex_data.nationality
            : 'HIDE',
        date_of_birth:
          this.getMerchant.booking_engine_day_of_birth != 'HIDE'
            ? vuex_data.day_of_birth
            : 'HIDE',
      };

      if (vuex_data.first_name != '') {
        return_data.name = `${this.$capitalize(vuex_data.title)}. ${
          vuex_data.first_name
        }`;
        if (vuex_data.last_name != '')
          return_data.name += ` ${vuex_data.last_name}`;
      }

      return return_data;
    },
    ticket_owner() {
      return this.getBeCart.ticket_owner;
    },
    total_deposit() {
      return (
        this.getBeRoomDeposit +
        this.getBeAddtServiceDeposit +
        this.$totalAddtServiceModule()
      );
    },
    total_deposit_merchant() {
      let total = 0;
      if (this.payment_option.id && this.payment_option.id == 'pay_deposit') {
        let total_amount =
          this.getBeRoomTotal +
          this.getBeAddtServiceSubTotal +
          this.$totalAddtServiceModule();
        total =
          (total_amount * this.getMerchant.deposit_zero_minimum_deposit_value) /
          100;
        total = Math.ceil(total);
      }
      return total;
    },
    final_deposit() {
      let total = this.total_deposit;
      if (
        total == 0 &&
        this.payment_option.id &&
        this.payment_option.id == 'pay_deposit'
      ) {
        total = this.total_deposit_merchant;
      }
      return total;
    },
    is_payment_valid() {
      let pm_checker = this.payment_methods.filter((x) => x.is_selected);
      return pm_checker.length == 1 ? true : false;
    },
    show_room_cart() {
      return this.cart_step == 1 ? true : false;
    },
    check_email_visitor() {
      let display = true;
      if (this.radio_button == 'other') {
        if (this.getIsCartVisitorEmail) {
          display = true;
        } else {
          display = false;
        }
      }
      return display;
    },
    button_submit_text() {
      let text = '';
      if (this.cart_step == 1) {
        if (
          this.total_deposit == 0 &&
          (!this.payment_option.id ||
            (this.payment_option.id &&
              this.payment_option.id == 'cc_guarantee'))
        ) {
          text = this.$t('hotel.action.book-now');
        } else {
          text = this.$t('hotel.proceed-to-payment');
        }
      } else {
        text = this.$t('general.payment');
      }
      return text;
    },
    button_submit_not_valid() {
      let is_not_valid = true;
      if (this.cart_step == 1) {
        is_not_valid = !this.term_conditions_check;
      } else {
        is_not_valid = !this.is_payment_valid;
      }
      return is_not_valid;
    },
    show_guarantee_deposit() {
      if (
        this.total_deposit <= 0 &&
        (this.getMerchant.deposit_zero_use_cc_guarantee ||
          this.getMerchant.use_changeable_deposit_value) &&
        this.getBeBypassCcGuarantee
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    ticket_owner() {
      this.fillDataVisitor();
    }
  },
  destroyed(){
    if(this.clear_cart_when_destroyed){
      this.clearCart();
    }
  },
  created() {
    this.$validateActiveReward('HOTEL_PROMOTION');
  },
  mounted() {
    window.addEventListener('scroll', this.updateScroll);
    document.getElementById('hotel-room-booking').scrollIntoView({
      behavior: 'smooth',
    });
    window.addEventListener('beforeunload', () => {
      if (this.clear_cart_when_change_page) {
        this.clearCart();
        this.setLoadingPage(true);
      }
    })
    
    this.is_order_need_payment = this.total_deposit > 0 ? true : false;
    if (Object.keys(this.getBeTxPayment).length == 0) {
      this.loadFirstData();
    } else {
      this.getPaymentMethodList().then(() => {
        let pm_index = this.payment_methods.findIndex(
          (x) => x.data.id == this.getBeTxPayment.payment_method.id
        );
        if (pm_index != -1) {
          this.togglePayment(pm_index);
        } else {
          let pm_index_2 = this.payment_methods.findIndex(
            (x) =>
              (x.data.bank_name == 'XENDIT' ||
                x.data.bank_name == 'XENDIT_INTERNATIONAL') &&
              x.data.payment_method == 'CREDIT_CARD'
          );
          if (pm_index_2 != -1) {
            this.togglePayment(pm_index_2);
          }
        }
      });
      this.cart_step = 2;
      this.tx_payment = this.getBeTxPayment;
      this.show_xendit_cc_form = true;
    }
  },
  methods: {
    ...mapMutations([
      'setBeCustomer',
      'setActiveRoute',
      'setBeTicketOwner',
      'setBeVisitor',
      'resetBECart',
      'resetBeFilter',
      'setAgentId',
      'setBeTxPayment',
      'setSessionLog',
      'setMembershipRewardApplied',
      'setBeGuestData',
      'setMembershipReferral',
      'setLoadingPage'
    ]),
    handlePrimaryRef(ref) {
      this.productPrimaryRef = ref
    },
    handleTransportRouteRef(ref) {
      this.transportRouteRef = ref
    },
    formatCurrency(value) {
      return formatCurrency(value);
    },
    paymentMethodConverter(payment) {
      return paymentMethodConverter(payment);
    },
    applyPromoCode(data) {
      this.promo_code_applied_failed = data;
    },
    loadFirstData() {
      this.setActiveRoute('');
      if (!this.isNotLogin) {
        this.getUserProfile();
      } else {
        this.show_contact_form = true;
      }
      if (this.cart_step == 2) {
        this.getPaymentMethodList();
      }
      this.radio_button = this.getBeTicketOwner;

      // JOKUL
      let externalScript = document.createElement('script');
      externalScript.setAttribute('src', config.JOKUL_URL);
      document.head.appendChild(externalScript);
    },
    clearCart() {
      this.resetBECart();
      this.resetBeFilter();
      this.setAgentId('');
      this.$clearCartAdditionalService();
    },
    toggleClearCartDestroyed() {
      // this.error.inquiry = 'payment-pending';
      this.clear_cart_when_destroyed = true
      // this.clearCart();
    },
    getUserProfile() {
      this.show_contact_form = false;
      get('BASE', 'auth/profile').then((response) => {
        let res = response.data.user;
        let vuex_data = this.$deepCopy(this.getBeCart.customer_details);
        let params = {
          field: 'customer_details',
          data: [],
        };
        if (!this.$isNotEmpty(vuex_data.first_name)) {
          params.data.push({
            key: 'first_name',
            value: res.first_name,
          });
        }
        if (!this.$isNotEmpty(vuex_data.last_name)) {
          params.data.push({
            key: 'last_name',
            value: res.last_name,
          });
        }
        if (!this.$isNotEmpty(vuex_data.email)) {
          params.data.push({
            key: 'email',
            value: res.email,
          });
        }
        if (!this.$isNotEmpty(vuex_data.phone_number)) {
          params.data.push({
            key: 'phone_number',
            value: res.phone,
          });
        }
        if (!this.$isNotEmpty(vuex_data.title)) {
          params.data.push({
            key: 'title',
            value: res.prefix_name,
          });
        }
        if (!this.$isNotEmpty(vuex_data.country)) {
          params.data.push({
            key: 'country',
            value: res.country,
          });
        }
        if (!this.$isNotEmpty(vuex_data.nationality)) {
          params.data.push({
            key: 'nationality',
            value: res.nationality,
          });
        }
        if (!this.$isNotEmpty(vuex_data.day_of_birth)) {
          params.data.push({
            key: 'day_of_birth',
            value: res.day_of_birth,
          });
        }
        if (params.data.length > 0) {
          this.setBeGuestData(params);
        }
        this.show_contact_form = true;
      });
    },
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    detailRoom(data) {
      this.detail_room = data == false ? false : data.room_rate;
    },
    toggleAdjustPax(data = false) {
      if (typeof data == 'boolean') {
        this.adjust_pax = {
          show: false,
          data: {},
          valdiateAgeChild: false,
        };
      } else {
        this.adjust_pax = {
          show: true,
          data: data.room_rate,
          valdiateAgeChild: data.valdiateAgeChild
        };
      }
    },
    togglePopUp(data) {
      this.terms_conditions = data;
    },
    termConditionCheck() {
      this.term_conditions_check = !this.term_conditions_check;
      if (this.term_conditions_check) {
        this.terms_conditions = true;
      }
    },
    toggleVisitorForm() {
      this.visitor_form = !this.visitor_form;
      if (this.visitor_form) {
        this.visitor_form_key++;
      }
    },
    toggleRadio(data) {
      this.radio_button = data;
    },
    togglePayment(index) {
      for (let pm in this.payment_methods) {
        this.payment_methods[pm].is_selected = false;
      }
      this.payment_methods[index].is_selected = true;
      let payment_selected = this.payment_methods[index].data;
      this.pm_selected = payment_selected;
      let total = 0;
      if (payment_selected.surcharge_type == 'FIXED_AMOUNT') {
        total = payment_selected.surcharge_value;
      } else {
        total = (this.total_deposit / 100) * payment_selected.surcharge_value;
      }
      this.payment_surcharge =
        payment_selected.bank_name == 'XENDIT' &&
        payment_selected.payment_method == 'CREDIT_CARD'
          ? Math.ceil(total)
          : total;
    },
    fillDataVisitor() {
      if (this.ticket_owner == 'me') {
        this.setBeVisitor(this.getBeCart.customer_details);
      } else {
        this.setBeVisitor({
          first_name: '',
          last_name: '',
          phone_number: '',
          email: '',
          address: '',
          title: '',
          country: '',
          nationality: '',
          day_of_birth: '',
        });
      }
    },
    getPaymentMethodList() {
      return new Promise((done) => {
        this.pm_loader = true;
        this.error.payment_list = '';
        this.$postLog('PAYMENT', '', 'First Load', this.tx_inquiry.tx_order_id);
        const apiEndPoint = `merchant/${this.getMerchant.code}/payment-method`
        get('CORE_HOTEL', apiEndPoint, {module : 'booking-engine'}).then(
          (response) => {
            let res = response.data;
            if (res.success) {
              const paymentMethodList = res.data.map(payment => {
                const { channel, pg_company } = payment;
                payment.payment_method = payment.channel
                payment.payment_channel = payment.channel
                payment.bank_name = payment.pg_company
                return payment;
              })
              for (let pm of paymentMethodList) {
                let item = {
                  data: pm,
                  is_selected: false,
                };
                this.payment_methods.push(item);
              }
            } else {
              this.error.payment_list = res.message;
            }
            done();
            this.pm_loader = false;
          }
        );
      });
    },
    hitGogleAnalytics(event) {
      if (this.getMerchant.google_analytics_id != null) {
        if (this.getMerchant.google_analytics_id != '') {
          this.$gtag('event',event, { method: 'Google' });
        }
      }
    },
    toggleInvalidPax() {
      this.invalid_pax.show = !this.invalid_pax.show;
      if (this.invalid_pax.show) {
        let copy_data = this.$deepCopy(this.getBeIsInvalIdPax);
        copy_data = copy_data.map((x) => x.room_rate.name);
        this.invalid_pax.data = copy_data.join();
      } else this.invalid_pax.data = '';
    },
    openAdjustPaxFromWarning() {
      this.toggleInvalidPax();
      this.toggleAdjustPax({
        room_rate: this.getBeIsInvalIdPax[0],
        validateChildAge: false
      });
    },
    errorCheck() {
      return new Promise((success, fail) => {
        this.error_check = false;
        this.payment_option_error = false;
        this.visitor_form_valid = true;
        this.$refs.contact_form
          .validateForm()
          .then(() => {
            let nextStep = () => {
              if (
                this.show_guarantee_deposit &&
                this.total_deposit <= 0 &&
                this.getMerchant.deposit_zero_use_cc_guarantee &&
                !this.payment_option.id
              ) {
                this.error_check = true;
                this.payment_option_error = true;
                success();
              } else {
                if (
                  this.show_guarantee_deposit &&
                  this.final_deposit <= 0 &&
                  this.getMerchant.deposit_zero_use_cc_guarantee &&
                  this.payment_option.id == 'cc_guarantee'
                ) {
                  this.$refs.payment_option
                    .submitCC()
                    .then(() => {
                      this.submitInquiry().finally(() => {
                        success();
                      });
                    })
                    .catch((err) => {
                      if (err == 'room-not-available') {
                        this.error.inquiry = 'room not available';
                        this.push_loading.inquiry = false;
                      }
                      success();
                    });
                } else {
                  this.submitInquiry().finally(() => {
                    success();
                  });
                }
              }
            };

            let ticket_owner = this.getBeCart.ticket_owner;
            if (ticket_owner == 'other') {
              this.$refs.contact_visitor_form
                .validateForm()
                .then(() => {
                  nextStep();
                })
                .catch(() => {
                  this.error_check = true;
                  document.getElementById('visitor-form').scrollIntoView({
                    behavior: 'smooth',
                  });
                  this.$postLog('CART', '', 'Got an error on the visitor form');
                  this.visitor_form_valid = false;
                  success();
                });
            } else {
              nextStep();
            }
          })
          .catch(() => {
            this.error_check = true;
            document.getElementById('contact-form').scrollIntoView({
              behavior: 'smooth',
            });
            this.$postLog('CART', '', 'Got an error on the contact form');
            success();
          });
      });
    },
    submitAction() {
      return new Promise((success, fail) => {
        if (this.cart_step == 1) {

          if(this.getMerchant.booking_engine_child_age === "REQUIRED"){
            const validateChildAge = this.$refs.desktopCart.validateChildAge()
            if(!validateChildAge){
              success();
              return;
            }
          }


          if(this.$isNotEmptyV2(this.transportRouteRef)){
            let isValid = true;
            for (const item of this.transportRouteRef) {
              let result = item.validateServiceDate()
              if(isValid && !result){
                 isValid = false;
                 break;
              }
            }
            if(!isValid){
              success();
              return;
            }
          }
          
          let is_cc_guarantee =
            this.getMerchant.deposit_zero_use_cc_guarantee &&
            !this.payment_option.id;
          let is_cc_guarantee_invalid =
            this.payment_option.id &&
            this.payment_option.id == 'cc_guarantee' &&
            !this.payment_option_valid;

          if (
            this.show_guarantee_deposit &&
            (is_cc_guarantee || is_cc_guarantee_invalid)
          ) {

            this.payment_option_error = true;
            success();
          } else {
            if (this.getBeIsInvalIdPax.length > 0) {
              this.toggleInvalidPax();
              success();
            } else if (this.final_deposit == 0) {
              this.popup_deposit = 'show';
              this.error_check = '';
              success();
            } else {
              this.errorCheck().finally(() => {
                success();
              });
            }
          }
        } else {
          this.submitPayment().finally(() => {
            success();
          });
        }
      });
    },
    getInquiryParam() {
      let params = {
        merchant_id: this.getMerchant.id,
        room_rate_details: [],
        customer_details: JSON.parse(
          JSON.stringify(this.getBeCart.customer_details)
        ),
        additional_service_details: [],
        special_request_details: [],
        notes: this.getBeCart.note,
        custom_check_in_time: this.getBeCart.custom_time.check_in,
        custom_check_out_time: this.getBeCart.custom_time.check_out,
        region: 'Indonesia',
        device: 'web',
        agent_id: this.getAgentId,
        use_promotion_combine: true,
      };

      if (this.$isNotEmptyV2(this.getMembershipReferral)) {
        params.membership_referral_code =
          this.getMembershipReferral.membership_referral_code;
        params.membership_reward_id =
          this.getMembershipReferral.membership_reward_id;
      } else if (!this.isNotLogin && this.getMembershipRewardApplied.id) {
        params.membership_reward_id = this.getMembershipRewardApplied.id;
      }

      if (this.ticket_owner == 'other') {
        params.visitor_details = JSON.parse(
          JSON.stringify(this.getBeCart.visitor_details)
        );
        params.visitor_details.address = '';
      }
      params.customer_details.address = '';

      if (this.getBeFilter.promo_code != '') {
        params.promo_code = this.getBeFilter.promo_code;
      }
      
      for (let room of this.getBeCart.room_rate_details) {
        for (let i = 0; i < room.qty; i++) {
          let guest = room.guest[i];
          let room_item = {
            check_in_date: moment(this.getBeFilter.date.check_in).format(
              'YYYY-MM-DD'
            ),
            check_out_date: moment(this.getBeFilter.date.check_out).format(
              'YYYY-MM-DD'
            ),
            qty: 1,
            room_rate_id: room.room_rate.id_ori,
            adult: guest.included.adult + guest.extra.adult,
            child: guest.included.child + guest.extra.child,
            infant: guest.included.infant + guest.extra.infant,
            promo_combine_id:
              room.room_rate.best_price.promo_combine != null
                ? room.room_rate.best_price.promo_combine.id
                : null,
          };
          if(this.$isNotEmptyV3(guest.age)){
            if(this.$isNotEmptyV3(guest.age.child)){
              room_item.child_data = guest.age.child.map(age => {
                return {age : Number(age)} 
              })
            }

            if(this.$isNotEmptyV3(guest.age.infant)){
              room_item.infant_data = guest.age.infant.map(age => {
                return {age : Number(age)} 
              })
            }
          }
          
          
          // TRANSPORT PRODUCT
          if(this.$isNotEmptyV2(guest.products)){
            const reservationId = this.$createUUID();
            Object.assign(room_item, { group_id: reservationId });

            const {
              date: pickupDate = null,
              flight_number: pickupFlightNumber = ""
            } = this.$isNotEmptyV2(guest.PICKUP) ? guest.PICKUP : {} 

            const {
              date: dropoffDate = null,
              flight_number: dropoffFlightNumber = ""
            } = this.$isNotEmptyV2(guest.DROPOFF) ? guest.DROPOFF : {} 
            
            guest.products.forEach(productItem => {
              const { qty, data:{ cm_transport_route_type: routeType, id: productId }} = productItem
              const isRoundTrip = routeType === 'ROUNDTRIP'
              const isPickup = routeType === 'PICKUP'
              const isDropoff = routeType === 'DROPOFF'
              
              const generalDate = this.$isEmpty(pickupDate) ? dropoffDate : pickupDate 
              
              let product = { 
                qty, id: productId, group_id: reservationId, 
                date: this.$formatDateApi(generalDate)
              }
              
              if(isRoundTrip || isPickup){
                Object.assign(product, {pickup_service_date: this.$formatDateApi(pickupDate, false, true)})

                if(this.$isNotEmptyV2(pickupFlightNumber)){
                  Object.assign(product, { pickup_transport_code: pickupFlightNumber })
                }
              }

              if(isRoundTrip || isDropoff){
                Object.assign(product, {dropoff_service_date: this.$formatDateApi(dropoffDate, false, true)})

                if(this.$isNotEmptyV2(dropoffFlightNumber)){
                  Object.assign(product, { dropoff_transport_code: dropoffFlightNumber })
                }
              }

              params.additional_service_details.push(product)  
            });
            
          }
          
          params.room_rate_details.push(room_item);
        }
      }

      for (let special_request of this.getBeCart.special_request) {
        let special_request_item = {
          id: special_request.data.id,
          notes: special_request.note,
        };
        params.special_request_details.push(special_request_item);
      }

      // ADDITIONAL SERVICE
      if(this.$isNotEmptyV2(this.getBeCart.additional_service)){
        const additionalService = this.getBeCart.additional_service.map(product => {
          const { data: { id }, qty, flight_number='' } = product;
          const serviceDate = moment(this.getBeFilter.date.check_in).format('YYYY-MM-DD');

          let otherData = {}
          if(this.$isNotEmptyV2(flight_number)) Object.assign(otherData, {flight_number});
          
          return {
            id, qty,
            date: serviceDate,
            ...otherData
          }
        })

        params.additional_service_details.push(...additionalService);
      }

      let total_product_addt_other_module =
        this.getActivityTrxProducts.length +
        this.getOutletTrxProducts.length +
        this.getVoucherOrder.cart.length;

      if (total_product_addt_other_module > 0) {
        params.tx_merchant_pos = [];

        // SPA/ACTIVITY
        this.getActivityTrxProducts.forEach((activity) => {
          let {
            original_data: { product_merchant_pos, product_ga_pos_id },
            service_time,
            service_date,
            therapist_gender,
            place_choice,
          } = activity;

          let setupProduct = () => {
            let sub_param = {
              id: product_ga_pos_id,
              qty: activity.qty,
              notes: '',
              schedule_id: service_time.id ? service_time.id : null,
              service_date: moment(service_date).format('YYYY-MM-DD'),
              therapist_gender,
              place_choice,
            };
            let time = moment(service_time.schedule_start, 'HH:mm:ss').format(
              'HH:mm'
            );
            sub_param.service_date += ` ${time}`;

            return sub_param;
          };

          let tx_merchant_pos_index = params.tx_merchant_pos.findIndex(
            (x) => x.merchant_pos_id == product_merchant_pos[0].id
          );
          if (tx_merchant_pos_index != -1) {
            params.tx_merchant_pos[tx_merchant_pos_index].products.push(
              setupProduct()
            );
          } else {
            params.tx_merchant_pos.push({
              merchant_pos_id: product_merchant_pos[0].id,
              products: [setupProduct()],
            });
          }
        });

        // OUTLET
        this.getOutletTrxProducts.forEach((outlet) => {
          let { product_pos, product_merchant_pos, product_ga_pos_id } =
            outlet.product_data;

          let is_variant = outlet.variants.length > 0;

          let setupProduct = (id, qty, note) => {
            let sub_param = {
              id: id,
              qty: qty,
              notes: note,
              service_date: moment(this.getBeFilter.date.check_in).format(
                'YYYY-MM-DD'
              ),
            };
            let time = moment(
              this.getMerchant.check_in_time_start,
              'HH:mm:ss'
            ).format('HH:mm');
            sub_param.service_date += ` ${time}`;

            return sub_param;
          };

          if (is_variant) {
            let tx_merchant_pos_index = params.tx_merchant_pos.findIndex(
              (x) => x.merchant_pos_id == product_pos[0].id
            );
            outlet.variants.forEach((variant) => {
              let sub_param = setupProduct(
                variant.variant_data.product_ga_pos_id,
                variant.qty,
                variant.notes
              );
              if (tx_merchant_pos_index != -1) {
                params.tx_merchant_pos[tx_merchant_pos_index].products.push(
                  sub_param
                );
              } else {
                params.tx_merchant_pos.push({
                  merchant_pos_id: product_pos[0].id,
                  products: [sub_param],
                });
              }
            });
          } else {
            let tx_merchant_pos_index = params.tx_merchant_pos.findIndex(
              (x) => x.merchant_pos_id == product_merchant_pos[0].id
            );
            let sub_param = setupProduct(
              product_ga_pos_id,
              outlet.qty,
              outlet.notes
            );
            if (tx_merchant_pos_index != -1) {
              params.tx_merchant_pos[tx_merchant_pos_index].products.push(
                sub_param
              );
            } else {
              params.tx_merchant_pos.push({
                merchant_pos_id: product_merchant_pos[0].id,
                products: [sub_param],
              });
            }
          }
        });

        // VOUCHER
        this.getVoucherOrder.cart.forEach((voucher_parent) => {
          voucher_parent.product.forEach((voucher) => {
            let { data, is_variant, variant_list, notes, qty } = voucher;

            let setupProduct = (id, qty, note) => {
              let sub_param = {
                id: id,
                qty: qty,
                notes: note,
                service_date: moment(this.getBeFilter.date.check_in).format(
                  'YYYY-MM-DD'
                ),
              };
              let time = moment(
                this.getMerchant.check_in_time_start,
                'HH:mm:ss'
              ).format('HH:mm');
              sub_param.service_date += ` ${time}`;

              return sub_param;
            };

            let tx_merchant_pos_index = params.tx_merchant_pos.findIndex(
              (x) => x.merchant_pos_id == data.merchant_pos.id
            );

            if (is_variant) {
              variant_list.forEach((variant) => {
                let sub_param = setupProduct(
                  variant.data.product_ga_pos_id,
                  variant.qty,
                  variant.notes
                );
                if (tx_merchant_pos_index != -1) {
                  params.tx_merchant_pos[tx_merchant_pos_index].products.push(
                    sub_param
                  );
                } else {
                  params.tx_merchant_pos.push({
                    merchant_pos_id: data.merchant_pos.id,
                    products: [sub_param],
                  });
                }
              });
            } else {
              let sub_param = setupProduct(data.product_ga_pos_id, qty, notes);
              if (tx_merchant_pos_index != -1) {
                params.tx_merchant_pos[tx_merchant_pos_index].products.push(
                  sub_param
                );
              } else {
                params.tx_merchant_pos.push({
                  merchant_pos_id: data.merchant_pos.id,
                  products: [sub_param],
                });
              }
            }
          });
        });
      }

      const membershipRewardId = this.$generateRewardIdRoomPromotion();
      if(this.$isNotEmptyV2(membershipRewardId)){
        params.membership_reward_id = membershipRewardId;
      }
      return params;
    },
    submitInquiry() {
      return new Promise((done) => {
        this.push_loading.inquiry = true;
        this.error = {
          inquiry: '',
          payment: '',
        };

        let params = this.getInquiryParam();

        post('CORE_HOTEL', 'tx-inquiry', params).then((response) => {
          let res = response.data;
          if (res.success) {
            trackEvent('add_shipping_info');
            this.$postLog('CART', '', 'Inquiry Success', this.tx_inquiry.tx_order_id);
            this.sendToMetaCAPI('InitiateCheckout', res);
            if (this.final_deposit > 0) {
              document.getElementById('hotel-room-payment').scrollIntoView({
                behavior: 'smooth',
              });
            }
            this.tx_inquiry = res;
            if (this.final_deposit > 0) {
              this.getPaymentMethodList().then(() => {
                this.cart_step = 2;
                this.order_step = 3;
                this.push_loading.inquiry = false;
              });
              done();
            } else {
              this.push_loading.inquiry = true;
              this.submitPayment().finally(() => {
                done();
              });
            }
          } else {
            this.error.inquiry = res.message;
            this.push_loading.inquiry = false;
            done();
          }
        });
      });
    },
    submitPayment() {
      return new Promise((done) => {
        if (this.is_payment_valid || this.final_deposit == 0) {
          this.$postLog('PAYMENT', '', 'Clicked Payment');
          this.hitGogleAnalytics('payment');
          this.push_loading.payment = true;
          let params = {
            tx_order_id: this.tx_inquiry.tx_order_id,
            use_promotion_combine: true,
            payment_details: {},
            total_deposit: Math.round(this.final_deposit),
            channex_pci_id: !(
              this.credit_card_guarantee_id == '' ||
              this.credit_card_guarantee_id == 'error'
            )
              ? this.credit_card_guarantee_id
              : null,
          };

          if (this.$isNotEmptyV2(this.getMembershipReferral)) {
            params.membership_referral_code =
              this.getMembershipReferral.membership_referral_code;
            params.membership_reward_id =
              this.getMembershipReferral.membership_reward_id;
          } else if (!this.isNotLogin && this.getMembershipRewardApplied.id) {
            params.membership_reward_id = this.getMembershipRewardApplied.id;
          }

          let selected_payment =
            this.payment_methods.length == 0
              ? null
              : this.payment_methods.find((x) => x.is_selected);
          if (this.final_deposit > 0) {
            params.payment_details = {
              id: selected_payment.data.id,
              payment_method: selected_payment.data.payment_method,
              bank_name: selected_payment.data.bank_name,
              payment_channel: selected_payment.data.payment_method,
            };
          }

          const membershipRewardId = this.$generateRewardIdRoomPromotion();
          if(this.$isNotEmptyV2(membershipRewardId)){
            params.membership_reward_id = membershipRewardId;
          }

          post('CORE_HOTEL', 'tx-payment', params).then((response) => {
            let res = response.data;
            if (res.success) {
              const trackParams = this.final_deposit > 0 ? selected_payment.data.name : 'Pay at Hotel'
              trackEvent('add_payment_info', trackParams);
              this.$postLog(
                'PAYMENT',
                '',
                'Payment Success',
                this.tx_inquiry.tx_order_id
              );
              if(this.final_deposit > 0) {
                const metaCapiParams = {
                  payment_method_selected: selected_payment.data.name,
                  ...this.tx_inquiry
                }
                this.sendToMetaCAPI('AddPaymentInfo', metaCapiParams)
              }
              if (this.getSessionLog.saved_id != this.tx_inquiry.tx_order_id) {
                this.setSessionLog([
                  {
                    key: 'session',
                    value: this.$createUUID(),
                  },
                  {
                    key: 'saved_id',
                    value: this.tx_inquiry.tx_order_id,
                  },
                ]);
              }

              if (this.$isNotEmptyV2(this.getMembershipReferral))
                this.setMembershipReferral({});
              else if (!this.isNotLogin && this.getMembershipRewardApplied.id)
                this.setMembershipRewardApplied({});

              if (
                res.payment == null ||
                this.final_deposit == 0 ||
                selected_payment == null ||
                selected_payment.data.bank_name == 'BPD_BALI'
              ) {
                this.clear_cart_when_destroyed = true;
                this.$router.push({
                  name: 'BePaymentResult',
                  params: {
                    tx_order_id: this.tx_inquiry.tx_order_id,
                  },
                  query:{
                    tx_sk: res.tx_sk
                  }
                });
              } else if (selected_payment.data.bank_name == 'JOKUL_DOKU') {
                this.error.inquiry = '';
                if (selected_payment.data.payment_method == 'VIRTUAL_ACCOUNT') {
                  this.clear_cart_when_destroyed = true;
                  this.$router.push({
                    name: 'BePaymentResult',
                    params: {
                      tx_order_id: this.tx_inquiry.tx_order_id,
                    },
                    query:{
                      tx_sk: res.payment.tx_sk
                    }
                  });
                } else {
                  this.clear_cart_when_change_page = true;
                  loadJokulCheckout(res.payment.url);
                }
              } else if (selected_payment.data.bank_name == 'DOKU') {
                this.clear_cart_when_change_page = true;
                this.error.inquiry = 'redirect to payment';
                this.dkpayload.MALLID = res.payment.form.MALLID;
                this.dkpayload.BASKET = res.payment.form.BASKET;
                this.dkpayload.CHAINMERCHANT = res.payment.form.CHAINMERCHANT;
                this.dkpayload.AMOUNT = res.payment.form.AMOUNT;
                this.dkpayload.PURCHASEAMOUNT = res.payment.form.PURCHASEAMOUNT;
                this.dkpayload.TRANSIDMERCHANT =
                  res.payment.form.TRANSIDMERCHANT;
                this.dkpayload.WORDS = res.payment.form.WORDS;
                this.dkpayload.REQUESTDATETIME =
                  res.payment.form.REQUESTDATETIME;
                this.dkpayload.CURRENCY = res.payment.form.CURRENCY;
                this.dkpayload.PURCHASECURRENCY =
                  res.payment.form.PURCHASECURRENCY;
                this.dkpayload.SESSIONID = res.payment.form.SESSIONID;
                this.dkpayload.PAYMENTCHANNEL = res.payment.form.PAYMENTCHANNEL;
                this.dkpayload.NAME = res.payment.form.NAME;
                this.dkpayload.EMAIL = res.payment.form.EMAIL;
                this.dkpayload.ADDRESS = res.payment.form.ADDRESS;
                this.dkpayload.MOBILEPHONE = res.payment.form.MOBILEPHONE;
                this.dkpayload.COUNTRY = res.payment.form.COUNTRY;
                this.dkpayload.URL = res.payment.payment_url;
                this.$nextTick(() => {
                  this.$refs.FormDKload.submit();
                });
              } else if (selected_payment.data.bank_name == 'MIDTRANS') {
                this.clear_cart_when_change_page = true;
                let scriptTag = document.createElement('script');
                scriptTag.src = config.MIDTRANS_URL;
                scriptTag.setAttribute(
                  'data-client-key',
                  res.payment.client_key
                );
                document.head.appendChild(scriptTag);
                scriptTag.onload = function () {
                  window.snap.pay(res.payment.token);
                };
              } else if (
                (selected_payment.data.bank_name == 'XENDIT' ||
                  selected_payment.data.bank_name == 'XENDIT_INTERNATIONAL') &&
                selected_payment.data.payment_method == 'CREDIT_CARD'
              ) {
                this.setBeTxPayment(res.payment);
                this.tx_payment = res.payment;
                this.show_xendit_cc_form = true;
                document.getElementById('hotel-room-booking').scrollIntoView({
                  behavior: 'smooth',
                });
              } else if (
                selected_payment.data.bank_name == 'XENDIT_INTERNATIONAL' &&
                selected_payment.data.payment_method == 'DIRECT_DEBIT'
              ) {
                this.clear_cart_when_change_page = true;
                this.$openLink(res.payment.url_redirect);
              } else if (
                selected_payment.data.bank_name == 'IPAYMU' &&
                selected_payment.data.pg_mode == 'PG_HOSTED'
              ) {
                this.clear_cart_when_change_page = true;
                this.$openLink(res.payment.url);
              } else if (selected_payment.data.bank_name == 'CASHLEZ') {
                this.clear_cart_when_change_page = true;
                let new_tab_type =
                  selected_payment.data.pg_mode == 'PG_HOSTED'
                    ? 'default'
                    : '_blank';
                this.$openLink(res.payment.url, new_tab_type);
                if (selected_payment.data.pg_mode == 'MERCHANT_HOSTED') {
                  this.$router.push({
                    name: 'BePaymentResult',
                    params: {
                      tx_order_id: this.tx_inquiry.tx_order_id,
                    },
                    query:{
                      tx_sk: res.payment.tx_sk
                    }
                  });
                }
              } else if (
                selected_payment.data.bank_name == 'MALDIVE_BANK' &&
                selected_payment.data.payment_channel == 'CREDIT_CARD'
              ) {
                this.clear_cart_when_change_page = true;
                this.$openLink(res.payment.url_redirect);
              } else {
                this.clear_cart_when_destroyed = true;
                this.$router.push({
                  name: 'BePaymentResult',
                  params: {
                    tx_order_id: this.tx_inquiry.tx_order_id,
                  },
                  query:{
                    tx_sk: res.payment.tx_sk
                  }
                });
              }
            } else {
              this.error.payment = res.message;
              if (this.cart_step == 1) {
                this.popup_deposit = false;
              }
              // this.error.inquiry = 'invalid tx id'
            }
            this.push_loading.inquiry = false;
            this.push_loading.payment = false;
            done();
          });
        } else {
          done();
        }
      });
    },
    sendToMetaCAPI(eventName, inquiry){
      const params = {
        tx_order_id: inquiry.tx_order_id,
        ...inquiry.data,
        payment_method_selected: inquiry.payment_method_selected ? inquiry.payment_method_selected : null
      }

      this.$sendEventMetaConversionsAPI(eventName, params);
    },
    clearInquiryError() {
      this.error.inquiry = '';
    },
    clearPaymentError() {
      this.error.payment = '';
    },
    closeXenditCC() {
      this.tx_payment = {};
      this.show_xendit_cc_form = false;
      this.loadFirstData();
    },
    submitPaymentOption(data) {
      this.payment_option = data;
      this.is_order_need_payment = data.id == 'pay_deposit' ? true : false;
    },
    changeStatusCC(data) {
      this.payment_option_valid = data;
    },
    getCreditCardId(data) {
      if (data == 'error') {
        this.payment_option_error = true;
      } else {
        this.credit_card_guarantee_id = data;
      }
    },
    resetSavedReward() {
      this.setMembershipRewardApplied({});
      this.resetBECart();
      this.$router.push(`/${this.getMerchant.code}/booking`);
    },
    saveVisitorForm() {
      return new Promise((success, fail) => {
        setTimeout(() => {
          this.$refs.contact_visitor_form
            .validateForm()
            .then(() => {
              this.toggleVisitorForm();
              success();
            })
            .catch(() => fail());
        }, 300);
      });
    },
  },
};
</script>
<style scoped>
@media screen and (max-width: 992px) {
  .px-5 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}

@media screen and (max-width: 1200px) {
  .px-5 {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
  }
}

.text-truncate-inside p {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/hotel/be/BeCartDesktop.vue